<div class="d-flex align-items-stretch">
  <div [class]="firstColumnClassNames">
    <ng-container #firstColumn></ng-container>
  </div>
  <div [class]="secondColumnClassNames">
    <ng-container #secondColumn></ng-container>
  </div>
</div>